import { reinitializeSwipers } from '../utilities/swiper-element'
import { reanimateImages } from '../utilities/utils'

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
    this.observer = undefined
  }

  connectedCallback() {
    if (window.Shopify && Shopify.designMode) {
      this.handleDesignMode()
    } else {
      this.initializeRecommendations(this.dataset.productId)
    }
  }

  disconnectedCallback() {
    if (this._designModeListener) {
      document.removeEventListener('shopify:section:load', this._designModeListener)
    }
  }

  handleDesignMode() {
    this._designModeListener = (event) => {
      const sectionId = event?.detail?.sectionId
      // Only initialize if the loaded section matches this element's section
      if (sectionId && this.dataset.sectionId && sectionId !== this.dataset.sectionId) {
        return
      }

      setTimeout(() => {
        if (this.isConnected && this.dataset.productId) {
          this.loadRecommendations(this.dataset.productId)
        }
      }, 1000)
    }

    document.addEventListener('shopify:section:load', this._designModeListener)

    // Also try loading immediately with delay in case section already loaded
    setTimeout(() => {
      if (this.isConnected && this.dataset.productId && this.dataset.sectionId) {
        this.loadRecommendations(this.dataset.productId)
      }
    }, 1000)
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this)

    this.observer = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)
      this.loadRecommendations(productId)
    }, { rootMargin: '0px 0px 400px 0px' })

    this.observer.observe(this)
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendations = html.querySelector('product-recommendations')
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
          reanimateImages(this)

          if (this.querySelector('swiper-container')) {
            requestAnimationFrame(() => {
              reinitializeSwipers()
            })
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
}

customElements.define('product-recommendations', ProductRecommendations)
